import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { request } from './helper';
import { ReportsState, Report, PaginatedResponse } from '@/types'; // Import necessary types

// **Thunks**
export const reportsAll = createAsyncThunk<
  PaginatedResponse<Report>, // Return type: paginated response
  { id: string, page: number, perPage: number }, // Argument type
  {}
>('reports/all', async ({ id, page = 1, perPage = 20 }) => {
  const response = await request(`api/weekly-report/${id}?page=${page}&perPage=${perPage}`);
  if (response.success) {
    return {
      data: response.data, // List of reports
      pagination: response.pagination, // Pagination details
    };
  }
  throw new Error(response.error || 'Failed to fetch reports');
});

export const downloadReport = createAsyncThunk(
  "reports/downloadReport",
  async (id: number) => {
    const response = await request(
      "api/weekly-report/download",
      "POST",
      { id },
    );

    if (!response.success || !response.data) {
      throw new Error("Failed to download reports");
    }
  }
);

export const getAnsweredCallRecap = createAsyncThunk(
  "reports/answeredCallRecap",
  async (user_id: number) => {
    const response = await request(`api/report/answered-call-recap/${user_id}`,);
    return response.success ? response.data : response.error;
  }
);

// **Initial State**
const initialState: ReportsState = {
  reports: [],
  answeredCallRecap: [],
  pagination: null, // Initialize with null for pagination
  loading: false,
};

// **Slice**
export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get All Replies
    builder
      .addCase(reportsAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportsAll.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.reports = payload.data;
        state.pagination = payload.pagination; 
      })
      .addCase(reportsAll.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getAnsweredCallRecap.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAnsweredCallRecap.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.answeredCallRecap = payload;
      })
      .addCase(getAnsweredCallRecap.rejected, (state) => {
        state.loading = false;
      });
  },
});

// **Export Reducer**
export default reportsSlice.reducer;